import { type LOCALE } from '../../../../i18n'
import { urlNormalizeUri } from '../../../../url-handling'
import { type CmsGlossaryDefinition } from '../../../model/glossary/cmsGlossary'

/**
 * Builds a public glossary detail URL path from the glossary definition and
 * letter bucket. Applies the locale's language prefix where required and a
 * trailing slash through the URL normalizer.
 *
 * For example, the `marken` glossary and letter `a` in `de-DE` produce
 * `/marken/marken-beginnend-mit-a/`.
 * Throws if the letter is not `a` through `z` or `0-9`.
 */
export const cmsGlossaryBuildDetailsUrl = ({
  glossaryDefinition,
  letter,
  locale,
}: {
  glossaryDefinition: CmsGlossaryDefinition
  letter: string
  locale: LOCALE
}): string => {
  return urlNormalizeUri({
    locale,
    uri: `/${glossaryDefinition.prefix}/${glossaryDefinition.detailsPrefix}${letter}`,
  })
}
